import React, {useState, useEffect} from "react";
import BackButton from "components/Button/BackButton";
import SaveButton from "components/Button/SaveButton";
import useFetch from "utils/hooks/useFetch";
import { useNavigate } from "react-router-dom";
import { ApiResponseStatusUnauthorized, ApiResponseSuccess, FormTypeAdd, FormTypeEdit, ModalTypeConfirmation, ModalTypeFail, ModalTypeLoading, ModalTypeSuccess, StatusCodeActive, Undefined } from "utils/Constant";
import { ApiCreateProduct, ApiGetBrandList, ApiGetCategoryList, ApiGetProductById, ApiGetSystem, ApiUpdateProduct } from "utils/constants/api";
import { CheckResponse, GetStatus, money, removeNonNumeric } from "utils/helpers";
import { useModal } from "components/modal/ModalContext";
import Select from 'react-select'
import moment from "moment";
import ImageIcon from "assets/icon/ImageIcon";
import { FormCard, PagesFormTitle } from "components/Cards";
import { useCallApi } from "api/apiHooks";

export default function ProductForm(){
    let navigate = useNavigate()

    const { openModal, closeModal } = useModal()
    const { fetchSystem, fetchBrandList, fetchCategoryList, fetchCreateProduct, fetchUpdateProduct, fetchProductById } = useCallApi()

    const { fetch: apiGetBrandList } = useFetch(ApiGetBrandList)
    const { fetch: apiGetCategoryList } = useFetch(ApiGetCategoryList)
    const { fetch: apiGetProductById } = useFetch(ApiGetProductById)
    const { fetch: apiCreateProduct } = useFetch(ApiCreateProduct)
    const { fetch: apiUpdateProduct } = useFetch(ApiUpdateProduct)
    const { fetch: apiGetSystem } = useFetch(ApiGetSystem)
    
    let queryString = new URLSearchParams(window.location.search)
    let formType = queryString.get("formType")
    let productId = queryString.get("productId")

    const [brandOptions, setBrandOptions] = useState([])
    const [brand, setBrand] = useState('')
    const [categoryOptions, setCategoryOptions] = useState([])
    const [category, setCategory] = useState([])
    const [productName, setProductName] = useState('')
    const [description, setDescription] = useState('-')
    const [price, setPrice] = useState('')
    const [priceAfterDiscount, setPriceAfterDiscount] = useState('0')
    const [discount, setDiscount] = useState('0')
    const [status, setStatus] = useState('')
    const [createBy, setCreateBy] = useState('')
    const [createDate, setCreateDate] = useState('')
    const [updateBy, setUpdateBy] = useState('')
    const [updateDate, setUpdateDate] = useState('')
    const [productPhotoFile, setProductPhotoFile] = useState('')
    const [productPhotoFileUrl, setProductPhotoFileUrl] = useState('')
    const [tax, setTax] = useState('')

    // Event
    const handleProductPhotoChange = (e) => {
        setProductPhotoFile((e.target.files[0]));
        if (e.target.files[0] != null) {
            setProductPhotoFileUrl(URL.createObjectURL(e.target.files[0]));
        }
    }
    
    // Button Event
    const saveBtnClick = () => {
        if(validation()){
            openModal(ModalTypeConfirmation, {
                onConfirm: () => {
                    openModal(ModalTypeLoading)
    
                    if (formType === FormTypeAdd) {
                        fetchCreateProduct(
                            brand.value, 
                            category.value, 
                            productName, 
                            description,
                            price.replaceAll(',', ''), 
                            priceAfterDiscount, 
                            discount, 
                            productPhotoFile
                        ).then((res) => {
                            if (CheckResponse(res)) {
                                openModal(ModalTypeSuccess, {
                                    onSuccess: () => {
                                        closeModal()
                                        navigate("/product") 
                                    }
                                })
                            } else {
                                openModal(ModalTypeFail, { message: res.message })
                            }
                        })
                    } else {
                        fetchUpdateProduct(
                            productId,
                            brand.value,
                            category.value, 
                            productName, 
                            description,
                            price.replaceAll(',', ''), 
                            priceAfterDiscount, 
                            discount, 
                            productPhotoFile
                        ).then((res) => {
                            if (CheckResponse(res)) {
                                openModal(ModalTypeSuccess, {
                                    onSuccess: () => {
                                        closeModal()
                                        navigate("/product") 
                                    }
                                })
                            } else {
                                openModal(ModalTypeFail, { message: res.message })
                            }
                        })
                    }                    
                }
            })
        }
    }
    const backBtnClick = () => {
        navigate(-1)
    }
    
    const getProductById = async() => {
        let res = await apiGetProductById({
            data: {
                productId
            }
        })

        return res
    }

    // Function
    const validation = () => {
        if (brand === null){
            openModal(ModalTypeFail, { message: 'Brand is required!' })
            return false
        } else if (typeof(brand) === Undefined) {
            openModal(ModalTypeFail, { message: 'Brand is required!' })
            return false
        } else if (brand.value === '') {
            openModal(ModalTypeFail, { message: 'Brand is required!' })
            return false
        }
        if (category === null){
            openModal(ModalTypeFail, { message: 'Category is required!' })
            return false
        } else if (typeof(category) === Undefined) {
            openModal(ModalTypeFail, { message: 'Category is required!' })
            return false
        } else if (category.value === '') {
            openModal(ModalTypeFail, { message: 'Category is required!' })
            return false
        }
        if (productName === '') {
            openModal(ModalTypeFail, { message: 'Product Name is required!' })
            return false
        }
        if (price === '') {
            openModal(ModalTypeFail, { message: 'Price is required!' })
            return false
        }
        if (discount === '') {
            openModal(ModalTypeFail, { message: 'Discount is required!' })
            return false
        } else {
            if (parseInt(discount) > 100){
                openModal(ModalTypeFail, { message: 'Discount cannot exceeded 100!' })
                return false
            }
        }

        return true
    }
    
    useEffect(() => {
        if (price !== ''){
            let disc = discount === '' ? 0 : parseFloat(discount)
            let finalPrice = (parseFloat(price.replaceAll(',', '')) * (100 - disc) / 100) / ((100-parseInt(tax))/100)

            setPriceAfterDiscount(Math.ceil(finalPrice / 1000) * 1000)
        }
    }, [price, discount, tax])
    
    useEffect(() => {
        openModal(ModalTypeLoading)
        
        // Get Tax
        fetchSystem('tax').then((res) => {
            if (CheckResponse(res)) {
                setTax(res.data.systemValue)

                fetchBrandList('', '1', 1000, 0).then((res) => {
                    if (CheckResponse(res)) {
                        let data = res?.data?.listData
                        let tempData = [{ label: 'Select Brand', value: '' }]

                        data.map((data, i) => tempData.push({ label: data.brandName, value: String(data.brandId)}))

                        setBrandOptions(tempData)

                        fetchCategoryList('', '1', 1000, 0).then((res) => {
                            if (CheckResponse(res)) {
                                let data = res?.data?.listData
                                let tempData = [{ label: 'Select Category', value: '' }]

                                data.map((data, i) => tempData.push({ label: data.categoryName, value: String(data.categoryId)}))

                                setCategoryOptions(tempData)

                                // If Form Type Edit then get data
                                if (formType === FormTypeEdit) {
                                    getProductById().then((res) => {
                                        if (CheckResponse(res)) {
                                            let data = res.data

                                            setBrand({ label: data.brandName, value: data.brandId })
                                            setCategory(tempData.find((x) => x.value === String(data.categoryId)))
                                            setProductName(data.productName)
                                            setDescription(data.description === '' ? '-' : data.description)
                                            setPrice(money(data.price))
                                            setDiscount(data.discount)
                                            setStatus(data.status)
                                            setCreateBy(data.createBy)
                                            setCreateDate(data.createDate)
                                            setUpdateBy(data.updateBy)
                                            setUpdateDate(data.updateDate)
                                            setProductPhotoFileUrl(data.productPictureUrl)
                                            setPriceAfterDiscount(data.nettPrice)

                                            closeModal()
                                        } else {
                                            openModal(ModalTypeFail, { message: res.message })
                                        }
                                    })
                                } else {
                                    closeModal()
                                }
                            } else {
                                openModal(ModalTypeFail, { message: res.message })
                            }
                        })
                    } else {
                        openModal(ModalTypeFail, { message: res.message })
                    }
                })
            } else {
                openModal(ModalTypeFail, { message: res.message })
            }
        })
    }, [])

    return(
        <div className="flex p-3 min-h-full w-full">
            <div className="flex flex-col w-full justify-between gap-2 sm:bg-white sm:p-6 sm:rounded-xl sm:shadow-lg min-h-full">
                <div>
                    <PagesFormTitle 
                        title={'Product Detail'}
                        formType={formType}
                        status={status}
                        createDate={createDate}
                        updateDate={updateDate}
                        updateBy={updateBy}
                    />

                    <div className="mt-5 flex flex-col gap-3 ">
                        {/* Product Photo */}
                        <div className="flex flex-col sm:flex-row sm:items-center">
                            <div className="w-48">
                                <span>Product Photo</span>
                            </div>
                            <div className="px-4 hidden sm:block">
                                <span>:</span>
                            </div>
                            <div className="w-full sm:w-72">
                                <img
                                    className="w-auto h-[200px] object-cover mx-auto border rounded-md"
                                    src={productPhotoFileUrl}
                                    alt="ID"
                                />
                                <input className="hidden" id="productPhoto" type="file" accept=".jpg, .png, .jpeg, .gif|image/*" onChange={handleProductPhotoChange} />
                                <button onClick={() => document.getElementById('productPhoto').click()} 
                                    className="mt-2 px-3 py-2 bg-app-matte-black text-white rounded-md text-center cursor-pointer w-full flex gap-2 justify-center"
                                >
                                    <ImageIcon />
                                    Add Image
                                </button>
                            </div>
                        </div>

                        {/* Brand */}
                        <FormCard title='Brand'>
                            <Select options={brandOptions} value={brand} onChange={(e) => { setBrand(e) }} placeholder='Select Brand' />
                        </FormCard>

                        {/* Product Name */}
                        <FormCard title='Product Name'>
                            <input className="input" value={productName} onChange={(e) => { setProductName(e.target.value) }} maxLength={40} />
                        </FormCard>
                        
                        {/* Description */}
                        <FormCard title='Description'>
                            <input className="input" value={description} onChange={(e) => { setDescription(e.target.value) }} maxLength={40} />
                        </FormCard>

                        {/* Category */}
                        <FormCard title='Category'>
                            <Select options={categoryOptions} value={category} onChange={(e) => { setCategory(e) }} placeholder='Select Category' />
                        </FormCard>

                        {/* Price */}
                        <FormCard title='Selling Price'>
                            <input className="input" value={price} onChange={(e) => { setPrice(money(e.target.value)) }} maxLength={40} />
                        </FormCard>

                        {/* Discount */}
                        <FormCard title='Discount'>
                            <div className="flex items-center">
                                <input className="border rounded-lg py-2 px-3 w-16" value={discount} onChange={(e) => { setDiscount(removeNonNumeric(e.target.value)) }} maxLength={3} />
                                <span className="ml-2">%</span>
                            </div>
                        </FormCard>

                        {/* Tax */}
                        <FormCard title='Tax'>
                            <span>{tax} %</span>
                        </FormCard>

                        {/* Final Price */}
                        <FormCard title='Final Price'>
                            <span>{money(priceAfterDiscount)}</span>
                        </FormCard>
                    </div>
                </div>            

                {/* Button */}
                <div className="mt-5 flex flex-wrap justify-end gap-2">
                    <SaveButton onClick={saveBtnClick} visible={true} />
                    <BackButton onClick={backBtnClick} />
                </div>
            </div>
        </div>
        
    )
}
